<template>
  <div>
	
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Edit Statuses</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Name"
                  placeholder="Full name"
                />
              </CCol>
				<CCol sm="6">
                <CInput
                  label="Email"
                  placeholder="Email"
                />
              </CCol>			  
            </CRow>
			<CRow>
              <CCol sm="6">
                <CInput
                  label="Mobile Number"
                  placeholder="Mobile Number"
                />
              </CCol>
				<CCol sm="6">
                <CInput
                  label="Department"
                  placeholder="Department"
                />
              </CCol>			  
            </CRow>
			<CRow>
              <CCol sm="12">
                <CInput
                  label="Designation/Profession"
                  placeholder="Designation"
                />
              </CCol>							 
            </CRow>
            
			 <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18">Save</button>
			</CCol>
			 
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';

export default {
  name: 'Edit_statuses',
  data () {
    return {
      setSelected:"",
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],     
	  siteOptions : [],
      physicalOptions : ['New physical','LIQUID'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,
	  
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],			
    }
  },
  mounted () {
	$('.counterDiv').hide();
	$('.otherOptions').hide();	
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		console.log('call');
		this.$router.push({path:'Statuses_masters'})
	}
  }
}
</script>
